module.exports = __webpack_public_path__ + "assets/retina_DropPerpDetailed.03be433c6595a9b5f41f60de8c469bbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_DropPerpDetailed.png
// module id = 657
// module chunks = 0